import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Text from './Text';

const StyledQAContainer = styled.div`
  margin: 20px 0px 20px 0px;
`;

const StyledQAQuestion = styled.div`
  border-bottom: 1px solid black;
  margin: 0px 20px 10px 0px;
`;

const StyledQAAnswer = styled.div``;

const SimpleQA = ({ question, answer, key }) => (
  <StyledQAContainer key={key}>
    <StyledQAQuestion>
      <Text type="body1" medium>
        {question}
      </Text>
    </StyledQAQuestion>
    <StyledQAAnswer>{answer}</StyledQAAnswer>
  </StyledQAContainer>
);

SimpleQA.propTypes = {
  question: PropTypes.string,
  answer: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
};

SimpleQA.defaultProps = {
  question: '',
  answer: '',
};

export default SimpleQA;
